"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _loginConnector = _interopRequireDefault(require("../../../../../login/login-connector"));
var _eligibleRace = _interopRequireDefault(require("./eligible-race"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *******************************************************************************
// Display the possible races
// *******************************************************************************
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Competition"), /*#__PURE__*/_react.default.createElement("th", null, "Race"), /*#__PURE__*/_react.default.createElement("th", null, "Day"), /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null)));
const EligibleRacesTable = (0, _loginConnector.default)(
// *******************************************************************************
// Display the possible races
// *******************************************************************************

class extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getRacesWithSameName", (raceEligibilities, thisRaceName) => {
      return raceEligibilities.filter(re => re.race.raceName === thisRaceName).length;
    });
  }
  render() {
    const comp = this.props.competition;
    return /*#__PURE__*/_react.default.createElement("div", null, comp.entryTypeOverrides.filter(e => e.raceEligibilities.length).map(entryType => /*#__PURE__*/_react.default.createElement("div", {
      key: entryType.id
    }, /*#__PURE__*/_react.default.createElement("h3", null, entryType.entryTypeDescription), /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, entryType.raceEligibilities.map((raceEligibility, i) => /*#__PURE__*/_react.default.createElement(_eligibleRace.default, {
      key: raceEligibility.race.id,
      i: i,
      racesPerClassDiv: this._getRacesWithSameName(entryType.raceEligibilities, raceEligibility.race.raceName),
      raceEligibility: raceEligibility,
      yearID: this.props.yearID,
      competitionID: this.props.competition.id,
      competitionName: this.props.competition.competitionName,
      newEntry: this.props.newEntry
    })))))));
  }
});

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref2 = {
  status: true,
  canAddToWaitingList: true,
  canEnterNow: true,
  canPayNow: true,
  canRemoveEntry: true,
  text: true,
  textClass: true,
  entryID: true
};
var _ref3 = {
  id: true,
  raceName: true,
  eventDescription: true,
  competitionDivisionID: true,
  competitionDay: {
    dayDate: true
  },
  competitionDivision: {
    description: true,
    isFreeToEnter: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(EligibleRacesTable, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.competitionSlug) + ",yearID:" + JSON.stringify(+props.yearID) + ")"]: {
    competitionName: true,
    id: true,
    entryTypeOverrides: {
      id: true,
      entryTypeDescription: true,
      ["raceEligibilities(classDivisionID:" + JSON.stringify(props.newEntry.classDivisionID) + ")"]: {
        id: true,
        entryTypeID: true,
        ["eligibilityStatus(bibName:" + JSON.stringify(props.newEntry.bibName) + ",cseBibID:" + JSON.stringify(props.newEntry.cseBibID) + ")"]: _ref2,
        race: _ref3
      }
    }
  }
}));